import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { LowStockPage } from '../../features/reports/low-stock-page'
import { lowStockSearchSchema } from '../../features/reports/operational-search'

export const Route = createFileRoute('/_app/low-stock')({
  staticData: { crumb: 'lowStock' },
  validateSearch: lowStockSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  component: LowStockPage,
})
